import React, { useState } from 'react';
import { Box, Paper, Typography, Grid, Button, CircularProgress } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useSelector, useDispatch } from 'react-redux';
import { getWidgetColor } from '../../../redux/actions/widgetActions';
import { WIDGET_URL } from '../../../Config';
import useCallOnce from '../../../hooks/useCallOnce';
import { checkShopifyConnection } from '../../../redux/actions/shopifyActions';
import { validateToken } from '../../../redux/actions/validateAction';

const token = localStorage.getItem('token');

export default function Installation() {
  const dispatch = useDispatch();
  const { isConnected, stores, raw, loading } = useSelector((s) => s.shopify);
  const { widgetColor: reduxWidgetColor } = useSelector((s) => s.widget);
  const { userpackageinfos } = useSelector((state) => state.auth);
  const widgetColor = reduxWidgetColor || '#000000';

  const [copied, setCopied] = useState(false);

  useCallOnce('widget/install/bootstrap', () => {
    dispatch(getWidgetColor());
    dispatch(checkShopifyConnection());
    dispatch(validateToken());
  });

  const agentId = raw?.data?.user?.agentId || '';
  const domain = stores?.[0]?.storeUrl || '';
  const accessToken = raw?.data?.shopifyStores?.[0]?.accessToken || stores?.[0]?.accessToken || '';
  const themeId = raw?.data?.themeDetail?.[0]?.theme?.id || 'themeID';
  const appEmbedId = '76d2239ce16104dce1858d2a700b90a5';

  const handleInstallClick = () => {
    if (!domain) return;
    const storeName = domain.replace('.myshopify.com', '');
    const shopifyAdminUrl = `https://admin.shopify.com/store/${storeName}/themes/${themeId}/editor?context=apps&appEmbed=${appEmbedId}&token=${token}`;
    window.open(shopifyAdminUrl, '_blank');
  };

//   const handleCopyCode = async () => {
//     try {
//       await navigator.clipboard.writeText(`<script src="${WIDGET_URL}/chat-widget-bundled.js"></script>
// <script>
//   document.addEventListener('DOMContentLoaded', function() {
//     new ChatWidget('body', {
//       agentId: '${agentId}',
//       domain: "${domain}",
//       accessToken: "${accessToken}",
//       themeColor: '${widgetColor}'
//     });
//   });
// </script>`);
//       setCopied(true);
//       setTimeout(() => setCopied(false), 2000);
//     } catch (e) {
//       // noop
//     }
//   };

  return (
    <Box>
      {loading ? (
              <CircularProgress size={18} />
            ) : (
      !isConnected ? (
        <Paper sx={{ p: 3, borderRadius: 2 }}>
          {/* <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>Installation</Typography> */}
          <Typography variant="body2" sx={{ color: '#6b7280' }}>
            Shopify Not Connected
          </Typography>
        </Paper>
      ) : (
        <>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>Installation Method</Typography>
          <Paper sx={{ p: 3, borderRadius: 2 }}>
            <Grid container spacing={2}>
              <Grid size={{ xs: 12, lg: 6 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexDirection: { xs: 'column', sm: 'row' }, gap: { xs: 2, sm: 0 } }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                    <CheckCircleIcon sx={{ fontSize: 32, color: '#10b981' }} />
                    <Box>
                      <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#111827', fontSize: { xs: '1rem', sm: '1.125rem' } }}>
                        Quick Installation for Shopify
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#6b7280', fontSize: { xs: '13px', sm: '14px' } }}>
                        To add Chat, click Install then Save in the new Shopify window without editing anything.
                      </Typography>
                    </Box>
                  </Box>
                  <Button 
                  variant="outlined" 
                  size="small" 
                  onClick={handleInstallClick} 
                  // disabled={!domain}
                  disabled={!userpackageinfos ? true : false}
                    sx={{ 
                      background: copied ? '#333333' : '#000000',
                       color: '#ffffff',
                        border: copied ? 'none' : '1px solid #000000', 
                        borderRadius: 2,
                         textTransform: 'none', 
                        fontWeight: 500, 
                        minWidth: '100px', 
                        px: 2, 
                        py: 1,
                        '&:disabled': {
                          background: '#333333',
                          border: 'none',
                          color: '#ffffff',
                          border: '1px solid #000000',
                          cursor: 'not-allowed'
                        }
                        }}>
                    {raw?.data?.shopifyStores?.[0]?.is_connected_to_brand ? 'Uninstall' : 'Install'}
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Paper>

          {/* <Paper sx={{ mt: 3, p: 3, borderRadius: 2 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>Manual Installation</Typography>
            <Typography variant="body2" sx={{ mb: 2, color: '#6b7280' }}>
              Follow these steps to install the chat widget on your Shopify store:
            </Typography>
            <Box component="ol" sx={{ pl: 3, mb: 3 }}>
              <Typography component="li" variant="body2" sx={{ mb: 1, color: '#6b7280' }}>Go to your store's admin panel and search for <strong>Themes</strong></Typography>
              <Typography component="li" variant="body2" sx={{ mb: 1, color: '#6b7280' }}>Click the <strong>three-dot menu</strong> next to Customize, then click <strong>Edit code</strong></Typography>
              <Typography component="li" variant="body2" sx={{ mb: 1, color: '#6b7280' }}>Open file <strong>theme.liquid</strong>, scroll down to the bottom and find the <code>&lt;/body&gt;</code> tag</Typography>
              <Typography component="li" variant="body2" sx={{ mb: 1, color: '#6b7280' }}>Paste the code below directly above the <code>&lt;/body&gt;</code> tag</Typography>
            </Box>
            <Box sx={{ background: '#f5f5f5', border: '1px solid #e0e0e0', borderRadius: 1, p: 2, mb: 2, fontFamily: 'monospace', fontSize: '12px', overflow: 'auto' }}>
              <Box component="pre" sx={{ margin: 0, whiteSpace: 'pre-wrap' }}>
{`<script src="${WIDGET_URL}/chat-widget-bundled.js"></script>
<script>
    document.addEventListener('DOMContentLoaded', function() {
        new ChatWidget('body', {
            agentId: '${agentId}',
            domain: "${domain}",
            accessToken: "${accessToken}",
            themeColor: '${widgetColor}'
        });
    });
</script>`}
              </Box>
            </Box>
            <Button variant="outlined" startIcon={<ContentCopyIcon />} size="small" onClick={handleCopyCode}
              sx={{ background: copied ? '#333333' : '#000000', color: '#ffffff', border: copied ? 'none' : '1px solid #000000', borderRadius: 2, textTransform: 'none', fontWeight: 500, minWidth: '100px', px: 2, py: 1 }}>
              {copied ? 'Copied!' : 'Copy Code'}
            </Button>
          </Paper> */}
        </>
      ))}
    </Box>
  );
}


